import { FC, ReactNode } from 'react';
import { PdfFilResponse } from '../../types/media';
import { ContentResponse } from '../../types/shared';

interface IPdfFil {
  contentResponse: ContentResponse;
}

const PdfFil: FC<IPdfFil> = ({ contentResponse }): ReactNode => {
  const contentResponsePdf = contentResponse.content as PdfFilResponse;
  return <a href={contentResponsePdf.relativeSourceUrl} download>{contentResponse.name}</a>;
};

export default PdfFil;
